unit unit_Karte;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, WEBLib.Buttons, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.WebCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCWebBrowser, VCL.TMSFNCMaps,
  VCL.TMSFNCOpenLayers, VCL.TMSFNCCustomComponent, VCL.TMSFNCCloudBase,
  VCL.TMSFNCGeocoding, VCL.TMSFNCRouteCalculator;

type
  TKarte = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    btnzurueck: TButton;
    WebLabel2: TLabel;
    edtFromAddress: TEdit;
    btnroute: TButton;
    WebLabel1: TLabel;
    edtToAddress: TEdit;
    btnAnzeigen: TButton;
    Container3: THTMLContainer;
    container4: THTMLContainer;
    MGC: TTMSFNCGeocoding;
    Container5: THTMLContainer;
    FNCMAP: TTMSFNCOpenLayers;
    RouteCalculator1: TTMSFNCRouteCalculator;
    procedure WebFormShow(Sender: TObject);
    procedure btnAnzeigenClick(Sender: TObject);
    procedure btnrouteClick(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure FNCMAPMapInitialized(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    mykundehint:string;
  protected procedure LoadDFMValues; override; end;

var
  Karte: TKarte;
  mylongitude:double;
  mylatitude:double;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TKarte.btnrouteClick(Sender: TObject);
var
  mapsurl:string;
begin



 if (edtFromAddress.Text <> '') and (edtToAddress.Text <> '')  then
  begin
    //RouteCalculator1.CalculateRoute(edtFromAddress.Text, edtToAddress.Text);
    mapsurl:='https://www.google.com/maps/dir/'+edtfromaddress.Text+'/'+edtToAddress.Text;
    application.Navigate(mapsurl, ntblank);
  end
  else
    MessageDlg('Sie müssen Start- und Zieladresse eingeben',mtWarning, [MBOK]);
end;

procedure TKarte.btnzurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TKarte.FNCMAPMapInitialized(Sender: TObject);
begin
  btnAnzeigenClick(Sender);
end;

procedure TKarte.btnAnzeigenClick(Sender: TObject);
begin
  if edtToAddress.text<>'' then
  begin
    mgc.GetGeocoding(edtToAddress.text,
      procedure(const ARequest: TTMSFNCGeocodingRequest; const ARequestResult:TTMSFNCCloudBaseRequestResult)
      begin
        if (ARequestresult.Success) AND (ARequest.Items.Count > 0) then
        begin
          FNCMap.Options.DefaultZoomLevel:=15;
          FNCMap.SetCenterCoordinate(arequest.Items[0].Coordinate.Latitude,arequest.Items[0].Coordinate.Longitude);
          fncmap.Markers[0].Longitude:=arequest.Items[0].Coordinate.Longitude;
          fncmap.Markers[0].Latitude:=arequest.Items[0].Coordinate.Latitude;
          fncmap.markers[0].Title:='ZIEL';
        end;
      end
      );
  end;
end;

procedure TKarte.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Karte / Route</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  Container2.HTML.Text:='';
  container2.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  container3.parentelement:=myelement;
  container4.parentelement:=myelement;
  container5.parentelement:=myelement;
  myelement:=container5.ElementHandle;
  fncmap.parentelement:=myelement;






  myelement:=container3.ElementHandle;
  weblabel2.ParentElement:=myelement;
  edtFromAddress.ParentElement:=myelement;
  btnroute.ParentElement:=myelement;

  myelement:=container4.ElementHandle;
  weblabel1.ParentElement:=myelement;
  edtToAddress.ParentElement:=myelement;
  btnAnzeigen.ParentElement:=myelement;

  edtFromAddress.Text:=dm2.tableSYSDATPostleitzahl.AsString+' '+dm2.tableSYSDATOrt.AsString+', '+dm2.tableSYSDATStrasse.AsString;

end;

procedure TKarte.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel2 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  edtFromAddress := TEdit.Create(Self);
  btnroute := TButton.Create(Self);
  edtToAddress := TEdit.Create(Self);
  btnAnzeigen := TButton.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  container4 := THTMLContainer.Create(Self);
  MGC := TTMSFNCGeocoding.Create(Self);
  Container5 := THTMLContainer.Create(Self);
  FNCMAP := TTMSFNCOpenLayers.Create(Self);
  RouteCalculator1 := TTMSFNCRouteCalculator.Create(Self);

  WebLabel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  edtFromAddress.BeforeLoadDFMValues;
  btnroute.BeforeLoadDFMValues;
  edtToAddress.BeforeLoadDFMValues;
  btnAnzeigen.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  container4.BeforeLoadDFMValues;
  MGC.BeforeLoadDFMValues;
  Container5.BeforeLoadDFMValues;
  FNCMAP.BeforeLoadDFMValues;
  RouteCalculator1.BeforeLoadDFMValues;
  try
    Name := 'Karte';
    Width := 437;
    Height := 529;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    ElementPosition := epIgnore;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 15;
    WebLabel2.Top := 131;
    WebLabel2.Width := 24;
    WebLabel2.Height := 13;
    WebLabel2.AutoSize := False;
    WebLabel2.Caption := 'Start';
    WebLabel2.ElementClassName := 'h5 text-primary m-1';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.ElementPosition := epIgnore;
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthStyle := ssAuto;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 15;
    WebLabel1.Top := 188;
    WebLabel1.Width := 20;
    WebLabel1.Height := 13;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Ziel';
    WebLabel1.ElementClassName := 'h5 text-primary m-1';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epIgnore;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthStyle := ssAuto;
    WebLabel1.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 437;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.Align := alTop;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 41;
    Container2.Width := 437;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-column m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.Align := alTop;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 94;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    edtFromAddress.SetParentComponent(Self);
    edtFromAddress.Name := 'edtFromAddress';
    edtFromAddress.Left := 16;
    edtFromAddress.Top := 157;
    edtFromAddress.Width := 329;
    edtFromAddress.Height := 19;
    edtFromAddress.ChildOrder := 6;
    edtFromAddress.ElementClassName := 'form-control  input-sm';
    edtFromAddress.ElementFont := efCSS;
    edtFromAddress.ElementPosition := epIgnore;
    edtFromAddress.HeightStyle := ssAuto;
    edtFromAddress.HeightPercent := 100.000000000000000000;
    edtFromAddress.Text := 'edtFromAddress';
    edtFromAddress.WidthPercent := 100.000000000000000000;
    btnroute.SetParentComponent(Self);
    btnroute.Name := 'btnroute';
    btnroute.Left := 16;
    btnroute.Top := 207;
    btnroute.Width := 96;
    btnroute.Height := 25;
    btnroute.Caption := 'Route';
    btnroute.ChildOrder := 8;
    btnroute.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnroute.ElementFont := efCSS;
    btnroute.ElementPosition := epIgnore;
    btnroute.HeightStyle := ssAuto;
    btnroute.HeightPercent := 100.000000000000000000;
    btnroute.WidthStyle := ssAuto;
    btnroute.WidthPercent := 100.000000000000000000;
    SetEvent(btnroute, Self, 'OnClick', 'btnrouteClick');
    edtToAddress.SetParentComponent(Self);
    edtToAddress.Name := 'edtToAddress';
    edtToAddress.Left := 16;
    edtToAddress.Top := 182;
    edtToAddress.Width := 329;
    edtToAddress.Height := 19;
    edtToAddress.ChildOrder := 1;
    edtToAddress.ElementClassName := 'form-control  input-sm';
    edtToAddress.ElementFont := efCSS;
    edtToAddress.ElementPosition := epIgnore;
    edtToAddress.HeightStyle := ssAuto;
    edtToAddress.HeightPercent := 100.000000000000000000;
    edtToAddress.Text := 'edtToAddress';
    edtToAddress.WidthPercent := 100.000000000000000000;
    btnAnzeigen.SetParentComponent(Self);
    btnAnzeigen.Name := 'btnAnzeigen';
    btnAnzeigen.Left := 16;
    btnAnzeigen.Top := 238;
    btnAnzeigen.Width := 96;
    btnAnzeigen.Height := 25;
    btnAnzeigen.Caption := 'anzeigen';
    btnAnzeigen.ChildOrder := 2;
    btnAnzeigen.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnAnzeigen.ElementFont := efCSS;
    btnAnzeigen.ElementPosition := epIgnore;
    btnAnzeigen.HeightStyle := ssAuto;
    btnAnzeigen.HeightPercent := 100.000000000000000000;
    btnAnzeigen.WidthStyle := ssAuto;
    btnAnzeigen.WidthPercent := 100.000000000000000000;
    SetEvent(btnAnzeigen, Self, 'OnClick', 'btnAnzeigenClick');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 102;
    Container3.Top := 103;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    container4.SetParentComponent(Self);
    container4.Name := 'container4';
    container4.Left := 200;
    container4.Top := 110;
    container4.Width := 169;
    container4.Height := 41;
    container4.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    container4.HeightStyle := ssAuto;
    container4.WidthStyle := ssAuto;
    container4.ChildOrder := 2;
    container4.ElementFont := efCSS;
    container4.ElementPosition := epIgnore;
    MGC.SetParentComponent(Self);
    MGC.Name := 'MGC';
    MGC.Left := 56;
    MGC.Top := 496;
    MGC.Width := 26;
    MGC.Height := 26;
    MGC.Visible := True;
    MGC.Service := gsOpenStreetMap;
    Container5.SetParentComponent(Self);
    Container5.Name := 'Container5';
    Container5.Left := 200;
    Container5.Top := 222;
    Container5.Width := 169;
    Container5.Height := 41;
    Container5.ElementClassName := 'd-flex m-1 border border-info';
    Container5.HeightStyle := ssAuto;
    Container5.WidthStyle := ssAuto;
    Container5.ChildOrder := 2;
    Container5.ElementFont := efCSS;
    Container5.ElementPosition := epIgnore;
    FNCMAP.SetParentComponent(Self);
    FNCMAP.Name := 'FNCMAP';
    FNCMAP.AlignWithMargins := True;
    FNCMAP.Left := 3;
    FNCMAP.Top := 332;
    FNCMAP.Width := 431;
    FNCMAP.Height := 194;
    FNCMAP.Margins.Top := 250;
    FNCMAP.Align := alClient;
    FNCMAP.ParentDoubleBuffered := False;
    FNCMAP.DoubleBuffered := True;
    FNCMAP.TabOrder := 11;
    SetEvent(FNCMAP, Self, 'OnMapInitialized', 'FNCMAPMapInitialized');
    FNCMAP.Markers.Clear;
    with FNCMAP.Markers.Add do
    begin
      Longitude := -74.044501999999990000;
      Latitude := 40.689247000000000000;
    end;
    FNCMAP.Options.Locale := 'de-DE';
    FNCMAP.Options.DefaultLatitude := 40.689247000000000000;
    FNCMAP.Options.DefaultLongitude := -74.044501999999990000;
    FNCMAP.Options.DefaultZoomLevel := 14.000000000000000000;
    FNCMAP.LocalFileAccess := True;
    FNCMAP.RouteCalculator := RouteCalculator1;
    RouteCalculator1.SetParentComponent(Self);
    RouteCalculator1.Name := 'RouteCalculator1';
    RouteCalculator1.Left := 136;
    RouteCalculator1.Top := 296;
    RouteCalculator1.Width := 26;
    RouteCalculator1.Height := 26;
    RouteCalculator1.Visible := True;
    RouteCalculator1.Service := csOpenRouteService;
    RouteCalculator1.Routes.Clear;
    with RouteCalculator1.Routes.Add do
    begin
      ID := '';
      Active := True;
    end;
    RouteCalculator1.Options.IncludeAlternativeRoutes := True;
  finally
    WebLabel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    edtFromAddress.AfterLoadDFMValues;
    btnroute.AfterLoadDFMValues;
    edtToAddress.AfterLoadDFMValues;
    btnAnzeigen.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    container4.AfterLoadDFMValues;
    MGC.AfterLoadDFMValues;
    Container5.AfterLoadDFMValues;
    FNCMAP.AfterLoadDFMValues;
    RouteCalculator1.AfterLoadDFMValues;
  end;
end;

end.
